module.exports = __webpack_public_path__ + "img/headingEle.b482efde.svg";